import { ICustomReportFilter } from '@principle-theorem/principle-core/interfaces';
import { Timezone } from '@principle-theorem/shared';
import {
  ComparableObject,
  ComparableValue,
  Dimension,
  Group,
} from 'crossfilter2';
import { IGroupedDimension } from './grouped-dimension';
import { IReportingQuery } from './querying';

export interface IMeasure {
  propertyName: string;
  query: IReportingQuery;
  dataAccessor: DataAccessor;
  filterAccessor: FilterAccessor;
  labelAccessor?: LabelAccessor;
  sortAccessor?: DataAccessor;
  reduceBy?: ReduceByFunction;
}

export type DataAccessor = (fact: unknown) => ComparableValue;
export type LabelAccessor = (fact: unknown) => string;
export type ColourAccessor = (fact: unknown) => string;
export type ArrayDataAccessor = (
  fact: unknown
) => (ComparableValue | IGroupedDimension)[];

export interface IAccessorContext {
  timezone: Timezone;
}

export type FilterAccessor = (
  filter: ICustomReportFilter,
  context: IAccessorContext
) => string | undefined;

export type ReduceByFunction = (
  dimension: Dimension<unknown, ComparableObject>
) => Group<unknown, IGroupedDimension, ComparableObject>;

export interface IMeasureFilter {
  value(measure: Pick<IMeasure, 'propertyName'>): string;
}
